import { useState, useEffect } from 'react'
import { getCurrentUserProfile, type UserProfile } from '@/lib/services/user-profile'
import { clientLogger } from '@/lib/client-logger'

const log = clientLogger('useUserProfile')
import { getSupabaseClient } from '@/lib/auth/client'

export function useUserProfile() {
  const [profile, setProfile] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchProfile = async () => {
    try {
      setLoading(true)
      setError(null)
      const userProfile = await getCurrentUserProfile()
      setProfile(userProfile)
    } catch (err) {
      log.error('Error fetching user profile:', err)
      setError('Failed to load user profile')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchProfile()

    // Listen for auth state changes
    const supabase = getSupabaseClient()
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event: string) => {
      if (event === 'SIGNED_IN' || event === 'SIGNED_OUT') {
        fetchProfile()
      }
    })

    return () => subscription.unsubscribe()
  }, [])

  // Computed values
  const displayName = profile?.firstName?.charAt(0).toUpperCase() || profile?.email?.charAt(0).toUpperCase() || 'U'

  const isLinkedToPeople = !!profile?.firstName

  return {
    profile,
    loading,
    error,
    displayName,
    isLinkedToPeople,
    refetch: fetchProfile
  }
}
